<template>
  <b-row
    v-if="contractData"
  >
    <b-col cols="12">
      <contract-info-card
        :contract-data="contractData"
        @update-contract="updateContract"
      />
    </b-col>

    <b-col cols="12">
      <contract-update-list
        :contract-data="contractData"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import ContractInfoCard from './ContractInfoCard.vue'
import ContractUpdateList from './ContractUpdateList.vue'
// eslint-disable-next-line import/no-cycle
import useContractView from './useContractView'

export default {
  components: {
    BRow,
    BCol,

    ContractInfoCard,
    ContractUpdateList,
  },
  props: {

  },
  data() {
    return {

    }
  },
  setup() {
    const { contractData, updateContract } = useContractView()
    return {
      contractData,
      updateContract,
    }
  },
}
</script>

<style>

</style>
